import Accordion from "components/accordion/Accordion";
import ActionsDropdown from "components/button/ActionsDropdown";
import CourtInfoCard from "components/card/CourtInfoCard";
import FileRow from "components/file-components/file-row";
import EditIcon from "components/icon/EditIcon";
import ReadMoreText from "components/ReadMoreText";
import { Referral, ReferralFormData } from "types";
import { getAvatarBgColor, getInitials } from "utils/helper";

const ReferralDisplay: React.FC<{
  formState: ReferralFormData;
  isEditMode: boolean;
  isEditing: boolean;
  isAssetCoordinator: boolean;
  onEditClick: () => void;
  prohabition_request_registration_number?: string | null;
  action_status: string;
  fileRowProps: any;
  asset_recovery_request_registration_number?: string | null;
  hasCourtData: boolean | null;
  referral?: Referral | null;
  hasRecoveryCourtData: boolean;
  assignedProsecutor: string | null;
  reinitiate_request_documents?: File[] | null;
  setIsProsecutorReassignPopupOpen?: React.Dispatch<
    React.SetStateAction<boolean>
  >;
  setIsForwardPopupOpen?: React.Dispatch<React.SetStateAction<boolean>>;
  setIsReinitiateRequestPopupOpen?: React.Dispatch<
    React.SetStateAction<boolean>
  >;
  setIsSuspensionRequestPopupOpen?: React.Dispatch<
    React.SetStateAction<boolean>
  >;
}> = ({
  formState,
  isAssetCoordinator,
  isEditMode,
  isEditing,
  onEditClick,
  prohabition_request_registration_number,
  action_status,
  fileRowProps,
  asset_recovery_request_registration_number,
  hasCourtData,
  referral,
  hasRecoveryCourtData,
  assignedProsecutor,
  setIsProsecutorReassignPopupOpen,

  reinitiate_request_documents,
}) => {
  const initials = getInitials(assignedProsecutor as string);
  const bgColor = getAvatarBgColor(assignedProsecutor as string);
  return (
    <>
      <div className="flex items-center gap-3">
        {" "}
        {prohabition_request_registration_number !== null &&
          prohabition_request_registration_number !== "" && (
            <div className="bg-red-600 rounded-md p-2 text-white w-fit text-[12px] border-none">
              <p className="font-light">Prohibition Reg No</p>
              <p className="font-semibold">
                {prohabition_request_registration_number}
              </p>
            </div>
          )}
        {asset_recovery_request_registration_number !== null &&
          asset_recovery_request_registration_number !== "" && (
            <div className="bg-red-600 rounded-md p-2 text-white w-fit text-[12px] border-none">
              <p className="font-light">Asset Recovery Registration Number</p>
              <p className="font-semibold">
                {asset_recovery_request_registration_number}
              </p>
            </div>
          )}
      </div>
      <div className="flex items-start gap-2 flex-col mt-3">
        {hasCourtData && (
          <CourtInfoCard
            court_info={referral?.prohabition_court_level as string}
            court_reg={
              referral?.prohabition_request_court_registration_number as string
            }
            date={referral?.prohabition_request_first_hearing_date as string}
            type={"Prohibition"}
            court_name={referral?.prohabition_court_name}
            court_level={referral?.prohabition_court_level}
            court_region={referral?.prohabition_court_region}
            court_zone={referral?.prohabition_court_zone}
            court_woreda={referral?.prohabition_court_woreda}
          />
        )}
        {hasRecoveryCourtData && (
          <CourtInfoCard
            court_info={referral?.asset_recovery_court_level as string}
            court_reg={
              referral?.asset_recovery_request_court_registration_number as string
            }
            date={referral?.asset_recovery_first_hearing_date as string}
            type={"Asset Recovery"}
            court_name={referral?.asset_recovery_court_name}
            court_level={referral?.asset_recovery_court_level}
            court_region={referral?.asset_recovery_court_region}
            court_zone={referral?.asset_recovery_court_zone}
            court_woreda={referral?.asset_recovery_court_woreda}
          />
        )}
        {/* {
            hasCourtData&&(
              <CourtInfoCard
              court_info={referral?.prohabition_court_level as string}
              court_reg={referral?.prohabition_request_court_registration_number as string}
              date={referral?.prohabition_request_first_hearing_date as string}
              type={"Prohibition"}
              />
            )
          }
          {
            hasRecoveryCourtData&&(
              <CourtInfoCard
              court_info={referral?.asset_recovery_court_level as string}
              court_reg={referral?.asset_recovery_request_court_registration_number as string}
              date={referral?.asset_recovery_request_first_hearing_date as string}
              type={"Asset Recovery"}
              />
            )
          } */}
      </div>
      <div className="flex justify-between items-center mt-3">
        <h3 className="text-base font-semibold mb-4">Referral Information</h3>
        {isEditMode &&
          !isEditing &&
          isAssetCoordinator &&
          action_status === "Pending" && (
            <button
              type="button"
              onClick={onEditClick}
              className="flex items-center gap-2 px-4 py-2 text-black rounded-lg transition-colors"
            >
              <EditIcon />
              Edit
            </button>
          )}
      </div>
      <div className="space-y-3">
        <div className="flex justify-between items-center">
          <span className="text-gray-700 font-medium">Status</span>
          <span className="bg-red-800 text-white px-3 py-1 rounded-md font-semibold text-sm">
            {formState.action_status || "Pending"}
          </span>
        </div>
        <div className="flex justify-between">
          <span style={{ color: "#6B7280" }}>Reception Office</span>
          <span style={{ color: "#000000" }}>
            {formState.receiving_office || "—"}
          </span>
        </div>
        <div className="flex justify-between">
          <span style={{ color: "#6B7280" }}>Reception Method</span>
          <span style={{ color: "#000000" }}>
            {formState.reception_method || "—"}
          </span>
        </div>

        {formState.letter_number && (
          <div className="flex justify-between">
            <span style={{ color: "#6B7280" }}>Letter Number</span>
            <span className="font-medium" style={{ color: "#000000" }}>
              {formState.letter_number}
            </span>
          </div>
        )}
        <div className="flex justify-between">
          <span style={{ color: "#6B7280" }}>Date</span>
          <span style={{ color: "#000000" }}>
            {formState.date?.split("T")[0] || "—"}
          </span>
        </div>
        <div className="flex flex-col">
          <span style={{ color: "#6B7280" }}>Referral Summary</span>
          <div style={{ color: "#000000" }}>
            {formState.referal_summary ? (
              <ReadMoreText text={formState.referal_summary} maxLines={3} />
            ) : (
              "—"
            )}
          </div>
        </div>
        {/* {referral?.(<div className="flex justify-between">
          <span style={{ color: "#432101AB" }}>Date</span>
          <span style={{ color: " var(--Prime-Blue, #0A1D39)" }}>
            {formState.date || "—"}
          </span>
        </div>)} */}
        {formState?.letter_file && formState?.letter_file?.length > 0 && (
          <div className="flex flex-col">
            <span style={{ color: "#6B7280" }}>Letter Files</span>
            <div style={{ color: "#000000" }}>
              {formState?.letter_file.map((file, index) => (
                <FileRow file={file} key={index} {...fileRowProps} />
              ))}
            </div>
          </div>
        )}

        {assignedProsecutor && (
          <div className="flex gap-2  mt-4 flex-col">
            <p className="text-base font-semibold text-gray-800">
              Assigned Prosecutor
            </p>
            <div className="flex justify-between items-center border rounded-lg">
              <div className="flex items-center gap-2 p-3 ">
                {" "}
                <div
                  className={`w-10 h-10 rounded-full flex items-center
                         justify-center text-white text-lg font-semibold flex-shrink-0 mr-3 ${bgColor}`}
                >
                  {initials}
                </div>
                <div>
                  <p className="font-medium text-gray-800">
                    {assignedProsecutor || ""}
                  </p>
                  <p className="text-sm text-gray-500">Prosecutor</p>
                </div>
              </div>
              {isAssetCoordinator && (
                <button
                  className="mr-2"
                  type="button"
                  onClick={() => setIsProsecutorReassignPopupOpen?.(true)}
                >
                  <EditIcon />
                </button>
              )}
            </div>
          </div>
        )}

        {action_status === "Reinitiate Aproved" && (
          <Accordion title="Reinitiation Detail" mainTitle="">
            <div className="flex flex-col gap-3">
              {" "}
              {referral?.reinitiate_request_date && (
                <div className="flex justify-between">
                  <span style={{ color: "#6B7280", fontSize: "15px" }}>
                    Request Date
                  </span>
                  <span className="font-medium" style={{ color: "#000000" }}>
                    {referral?.reinitiate_request_date.split("T")[0]}
                  </span>
                </div>
              )}
              {referral?.reinitiate_reseaon_type && (
                <div className="flex justify-between">
                  <span style={{ color: "#6B7280", fontSize: "15px" }}>
                    Reason Type
                  </span>
                  <span className="font-medium" style={{ color: "#000000" }}>
                    {referral?.reinitiate_reseaon_type}
                  </span>
                </div>
              )}
              <div className="flex flex-col">
                <span style={{ color: "#6B7280", fontSize: "15px" }}>
                  Summary
                </span>
                <div style={{ color: "#000000" }}>
                  {referral?.reinitiate_request_summary ? (
                    <ReadMoreText
                      text={referral?.reinitiate_request_summary}
                      maxLines={3}
                      fontSize="14px"
                    />
                  ) : (
                    "—"
                  )}
                </div>
              </div>
              {reinitiate_request_documents &&
                reinitiate_request_documents?.length > 0 && (
                  <div className="flex flex-col">
                    <span style={{ color: "#6B7280", fontSize: "15px" }}>
                      Documents
                    </span>
                    <div style={{ color: "#000000" }}>
                      {reinitiate_request_documents.map((file, index) => (
                        <FileRow file={file} key={index} {...fileRowProps} />
                      ))}
                    </div>
                  </div>
                )}
            </div>
          </Accordion>
        )}

        {action_status === "Suspended" && (
          <Accordion title="Suspension Detail" mainTitle="">
            <div className="flex flex-col gap-3">
              {" "}
              {referral?.suspension_request_date && (
                <div className="flex justify-between">
                  <span style={{ color: "#6B7280", fontSize: "15px" }}>
                    Request Date
                  </span>
                  <span className="font-medium" style={{ color: "#000000" }}>
                    {referral?.suspension_request_date.split("T")[0]}
                  </span>
                </div>
              )}
              {referral?.suspension_reseaon_type && (
                <div className="flex justify-between">
                  <span style={{ color: "#6B7280", fontSize: "15px" }}>
                    Reason Type
                  </span>
                  <span className="font-medium" style={{ color: "#000000" }}>
                    {referral?.suspension_reseaon_type}
                  </span>
                </div>
              )}
              <div className="flex flex-col">
                <span style={{ color: "#6B7280", fontSize: "15px" }}>
                  Summary
                </span>
                <div style={{ color: "#000000" }}>
                  {referral?.suspension_request_summary ? (
                    <ReadMoreText
                      text={referral?.suspension_request_summary}
                      maxLines={3}
                      fontSize="14px"
                    />
                  ) : (
                    "—"
                  )}
                </div>
              </div>
              {referral?.suspension_request_documents &&
                referral?.suspension_request_documents?.length > 0 && (
                  <div className="flex flex-col">
                    <span style={{ color: "#6B7280", fontSize: "15px" }}>
                      Documents
                    </span>
                    <div style={{ color: "#000000" }}>
                      {referral?.suspension_request_documents.map(
                        (file, index) => (
                          <FileRow file={file} key={index} {...fileRowProps} />
                        ),
                      )}
                    </div>
                  </div>
                )}
            </div>
          </Accordion>
        )}
      </div>
    </>
  );
};

export default ReferralDisplay;
